import foxGridReducer from 'fox-react/dist/components/FoxGrid/reducer';
import gridNames from 'common/gridNames';

const facilitiesManagementReducer = foxGridReducer(
  gridNames.facilitiesManagement,
);

export default facilitiesManagementReducer;
